import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';

export interface ListPaginationProps {
  page: number;
  pageCount: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  className?: string;
}

function rangeLabel(page: number, pageSize: number, total: number): string {
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return `${from}–${to} из ${total}`;
}

export function ListPagination({
  page,
  pageCount,
  total,
  pageSize,
  onPageChange,
  className,
}: ListPaginationProps): ReactNode {
  if (total === 0) return null;

  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        mt: 2,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {rangeLabel(page, pageSize, total)}
      </Typography>
      {pageCount > 1 && (
        <Pagination
          page={page}
          count={pageCount}
          onChange={(_, p) => onPageChange(p)}
          color="primary"
          showFirstButton
          showLastButton
        />
      )}
    </Box>
  );
}
